import { ProEditReasons } from '@mp/graphql/generated/graphql';

const PRO_EDIT_REASONS_LABELS: Record<ProEditReasons, string> = {
  [ProEditReasons.ForgotToClockOut]: 'Forgot to Clock Out',
  [ProEditReasons.ForgotToClockIn]: 'Forgot to Clock In',
  [ProEditReasons.ArrivedEarlyFacilityRequested]: 'Arrived Early (Facility Requested)',
  [ProEditReasons.StayedLateFacilityRequested]: 'Stayed Late (Facility Requested)',
  [ProEditReasons.IncorrectTimestampRecorded]: 'Incorrect Timestamp Recorded',
  [ProEditReasons.ConnectivityOrAppIssue]: 'Connectivity or App Issue',
  [ProEditReasons.Other]: 'Other',
};

export const EDIT_CLOCK_TIMES_REASONS = (
  Object.entries(PRO_EDIT_REASONS_LABELS) as [ProEditReasons, string][]
).map(([value, label]) => ({ value, label }));

export const REASON_OTHER_VALUE = ProEditReasons.Other;
